module.exports = __webpack_public_path__ + "static/nattokinase-f3ce92aa6e033868ccef334f1fc215af.png";